// ============================================================================
// Tienda online — UI strings (es / en / ca).
//
// `shop.*` is the public storefront, `ostore.*` the account's panel. Kept in
// its own module (merged into the main bundles by lib/i18n.js), like
// locales/catalogue.js.
// ============================================================================

const es = {
  nav: { online_store: 'Tienda online' },
  shop: {
    loading: 'Cargando la tienda…',
    notFoundTitle: 'Esta tienda no está disponible',
    notFoundBody: 'El enlace no es correcto o la tienda aún no está publicada.',
    errorTitle: 'No se ha podido cargar la tienda',
    errorBody: 'Comprueba tu conexión e inténtalo de nuevo.',
    draftBanner: 'Vista previa: la tienda aún no está publicada. Solo tú puedes verla y no admite pedidos.',
    searchPlaceholder: 'Buscar productos…',
    account: 'Mi cuenta',
    signIn: 'Iniciar sesión',
    signOut: 'Cerrar sesión',
    createAccount: 'Crear cuenta',
    noAccount: '¿Aún no tienes cuenta?',
    haveAccount: '¿Ya tienes cuenta?',
    forgotPassword: '¿Has olvidado la contraseña? Contacta con la tienda y te dará una nueva.',
    passwordHint: 'Mínimo 8 caracteres.',
    cart: 'Mi cesta',
    cartEmpty: 'Tu cesta está vacía.',
    categories: 'Categorías',
    allProducts: 'Todos los productos',
    resultsFor: 'Resultados para «{{q}}»',
    productCount_one: '{{count}} producto',
    productCount_other: '{{count}} productos',
    sort: 'Ordenar',
    sortName: 'Nombre',
    sortPriceAsc: 'Precio: de menor a mayor',
    sortPriceDesc: 'Precio: de mayor a menor',
    sortNewest: 'Novedades',
    sortFeatured: 'Destacados',
    otherProducts: 'Otros productos',
    photosCredit: 'Algunas fotos de producto:',
    emptyTitle: 'No hay productos',
    emptyBody: 'Esta sección aún no tiene productos.',
    emptySearch: 'Prueba con otra palabra o revisa la ortografía.',
    perLitre: '{{price}} / litro',
    add: 'Añadir',
    less: 'Quitar uno',
    more: 'Añadir uno',
    remove: 'Quitar de la cesta',
    close: 'Cerrar',
    inStock: 'Disponible',
    outOfStock: 'Agotado',
    vatIncluded: 'IVA incluido',
    pricesIncludeVat: 'Todos los precios incluyen IVA.',
    prevPage: 'Página anterior',
    nextPage: 'Página siguiente',
    pageOf: 'Página {{page}} de {{pages}}',
    page: 'Página',
    ofPages: 'de {{pages}}',
    firstPage: 'Primera página',
    lastPage: 'Última página',
    customerService: 'Atención al cliente',
    callUs: 'Llámanos al {{phone}}',
    writeUs: 'Escríbenos',
    whatsappUs: 'WhatsApp',
    register: 'Regístrate',
    searchLabel: 'Busca:',
    home: 'Inicio',
    hours: 'Horarios',
    deliveryAndPickup: 'Entrega y recogida',
    contact: 'Contacto',
    freeFrom: 'Envío gratis desde {{amount}}',
    minOrder: 'Pedido mínimo: {{amount}}',
    perUnit: '{{price}} / ud.',
    perKg: '{{price}} / kg',
    scrollLeft: 'Ver anteriores',
    scrollRight: 'Ver más',
    rightsReserved: 'Todos los derechos reservados.',
    subtotal: 'Subtotal',
    total: 'Total',
    free: 'Gratis',
    checkout: 'Tramitar pedido',
    ordersPaused: 'Ahora no admitimos pedidos',
    toFreeDelivery: 'Te faltan {{amount}} para el envío gratis.',
    belowMinimum: 'El pedido mínimo para envío a domicilio es de {{amount}}.',
    backToShop: 'Volver a la tienda',
    yourDetails: 'Tus datos',
    name: 'Nombre y apellidos',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    password: 'Contraseña',
    emailOptional: 'Correo electrónico (opcional)',
    nifOptional: 'NIF (si quieres factura)',
    howToReceive: '¿Cómo quieres recibirlo?',
    delivery: 'Envío a domicilio',
    pickup: 'Recogida en tienda',
    pickupHint: 'Te avisamos cuando esté listo.',
    deliveryCost: 'Coste de envío: {{amount}}',
    deliveryFree: 'Envío gratis',
    street: 'Dirección (calle, número, piso)',
    postcode: 'Código postal',
    city: 'Población',
    payment: 'Forma de pago',
    noPaymentMethods: 'La tienda aún no ha configurado formas de pago.',
    notes: 'Notas para el pedido',
    yourOrder: 'Tu pedido',
    acceptTerms: 'Acepto las condiciones de compra',
    placeOrder: 'Confirmar pedido',
    pay: {
      cash: 'Efectivo al recibir',
      card_on_delivery: 'Tarjeta al recibir (datáfono)',
      bizum: 'Bizum',
      transfer: 'Transferencia bancaria',
      online_card: 'Tarjeta online',
    },
    payHint: {
      cash: 'Pagas en efectivo al repartidor o en la tienda.',
      card_on_delivery: 'Pagas con tarjeta al repartidor o en la tienda.',
      bizum: 'Te indicamos el número al confirmar el pedido.',
      transfer: 'Te indicamos la cuenta al confirmar el pedido.',
      online_card: 'Pago seguro con tarjeta al confirmar el pedido.',
    },
    payStatus: { pending: 'Pendiente de pago', paid: 'Pagado', refunded: 'Devuelto' },
    status: {
      new: 'Recibido', accepted: 'Aceptado', preparing: 'En preparación', ready: 'Listo para recoger',
      shipped: 'En reparto', delivered: 'Entregado', cancelled: 'Cancelado',
    },
    orderReceived: '¡Pedido recibido!',
    orderCancelled: 'Pedido cancelado',
    orderNumber: 'Pedido {{number}}',
    orderNotFound: 'No encontramos este pedido.',
    vatLine: 'IVA {{rate}} % incluido',
    transferTo: 'Haz la transferencia a {{iban}} indicando el pedido {{number}}.',
    bizumTo: 'Envía el Bizum al {{phone}} indicando el pedido {{number}}.',
    payNowTitle: 'Pago del pedido',
    payByCard: 'Pagar {{amount}} con tarjeta',
    payConfirming: 'Confirmando el pago con el banco…',
    payFailed: 'El pago no se ha completado. Puedes intentarlo de nuevo.',
    myOrders: 'Mis pedidos',
    noOrders: 'Aún no has hecho ningún pedido.',
    myDetails: 'Mis datos',
    save: 'Guardar',
    saved: 'Guardado',
    err: {
      failed: 'No se ha podido completar. Inténtalo de nuevo.',
      accept_terms: 'Tienes que aceptar las condiciones de compra.',
      store_not_available: 'La tienda no está disponible ahora mismo.',
      orders_paused: 'La tienda no admite pedidos en este momento.',
      name_required: 'Indica tu nombre.',
      phone_invalid: 'Indica un teléfono válido.',
      email_invalid: 'El correo electrónico no es válido.',
      email_taken: 'Ya existe una cuenta con ese correo. Inicia sesión.',
      password_invalid: 'La contraseña debe tener al menos 8 caracteres.',
      bad_credentials: 'Correo o contraseña incorrectos.',
      rate_limited: 'Demasiados intentos. Espera unos minutos.',
      fulfilment_invalid: 'Esa forma de entrega no está disponible.',
      address_required: 'Indica la dirección de entrega completa.',
      postcode_not_served: 'No repartimos en ese código postal. Puedes elegir recogida en tienda.',
      payment_invalid: 'Esa forma de pago no está disponible.',
      items_invalid: 'La cesta no es válida.',
      items_unavailable: 'Algún producto ya no está disponible. Hemos actualizado tu cesta: revísala.',
      out_of_stock: 'Algún producto se ha agotado. Hemos actualizado tu cesta: revísala.',
      below_minimum: 'El pedido no llega al mínimo para envío a domicilio.',
      not_signed_in: 'Tu sesión ha caducado. Inicia sesión de nuevo.',
    },
  },
  ostore: {
    title: 'Tienda online',
    intro: 'Tu propia tienda web con los productos que ya tienes en zBilling: tus clientes compran online y los pedidos te llegan aquí.',
    schemaMissing: 'El módulo está activado pero pendiente de instalar en la base de datos. Contacta con soporte.',
    create: 'Crear mi tienda',
    draft: 'Borrador',
    published: 'Publicada',
    publish: 'Publicar tienda',
    unpublish: 'Despublicar',
    publishedToast: 'Tienda publicada: ya admite pedidos',
    unpublished: 'Tienda despublicada',
    preview: 'Vista previa',
    openShop: 'Abrir tienda',
    copyLink: 'Copiar enlace',
    linkCopied: 'Enlace copiado',
    save: 'Guardar cambios',
    saved: 'Cambios guardados',
    saveFailed: 'No se ha podido guardar',
    loadFailed: 'No se han podido cargar los pedidos',
    uploadFailed: 'No se ha podido subir la imagen (PNG, JPG o WebP, máx. 5 MB)',
    close: 'Cerrar',
    refresh: 'Actualizar',
    print: 'Imprimir',
    tab: { orders: 'Pedidos', reports: 'Informes de venta', articles: 'Artículos', customers: 'Clientes', settings: 'Configuración' },
    filter: { open: 'En curso', all: 'Todos' },
    searchOrders: 'Buscar pedido, cliente o teléfono…',
    noOrders: 'Aún no hay pedidos. Publica la tienda y comparte el enlace.',
    noOrdersFilter: 'Ningún pedido con ese filtro.',
    col: { order: 'Pedido', date: 'Fecha', customer: 'Cliente', receive: 'Entrega', payment: 'Pago', total: 'Total', status: 'Estado', contact: 'Contacto', since: 'Alta', orders: 'Pedidos' },
    product: 'Producto',
    qty: 'Cant.',
    price: 'Precio',
    vatBase: 'Base + IVA {{rate}} %',
    moveTo: {
      accepted: 'Aceptar pedido', preparing: 'Empezar a preparar', ready: 'Listo para recoger',
      shipped: 'Sale a reparto', delivered: 'Entregado', cancelled: 'Cancelar pedido',
    },
    markPaid: 'Marcar como pagado',
    markUnpaid: 'Marcar como no pagado',
    period: { today: 'Hoy', d7: '7 días', d30: '30 días', month: 'Este mes', year: 'Este año', all: 'Todo' },
    exportCsv: 'Exportar CSV',
    kpi: {
      sales: 'Ventas', vatIncluded: 'IVA incluido', orders: 'Pedidos', cancelled: '{{count}} cancelados', average: 'Ticket medio',
      customers: 'Clientes', paid: 'Cobrado', pending: 'Pendiente de cobro', delivery: 'Envíos a domicilio',
      deliveryFees: '{{amount}} en gastos de envío', pickup: 'Recogidas en tienda',
    },
    salesByDay: 'Ventas por día',
    topProducts: 'Productos más vendidos',
    byPayment: 'Por forma de pago',
    noData: 'Sin datos en este periodo.',
    noCustomers: 'Aún no hay clientes registrados en la tienda.',
    resetPassword: 'Nueva contraseña',
    resetPrompt: 'Nueva contraseña para {{email}} (mínimo 8 caracteres). Comunícasela al cliente:',
    resetDone: 'Contraseña cambiada',
    err: {
      failed: 'No se ha podido guardar',
      slug_invalid: 'La dirección solo admite minúsculas, números y guiones (3 a 60 caracteres)',
      slug_taken: 'Esa dirección ya la usa otra tienda',
      domain_invalid: 'El dominio no es válido (ejemplo: tienda.minegocio.es)',
      domain_taken: 'Ese dominio ya está conectado a otra tienda',
      forbidden: 'No tienes permiso para cambiar la tienda',
    },
    set: {
      identity: 'Tu tienda',
      name: 'Nombre de la tienda',
      tagline: 'Frase bajo la imagen de portada',
      slug: 'Dirección de la tienda',
      domain: 'Dominio propio (opcional)',
      domainHint: 'Si tienes tu propia web o dominio, escríbelo aquí y avisa a soporte para conectarlo.',
      logo: 'Logotipo',
      banner: 'Imagen de portada',
      colour: 'Color principal',
      notice: 'Aviso en la parte superior',
      contact: 'Contacto',
      address: 'Dirección de la tienda',
      website: 'Tu otra web',
      websiteHint: 'Se enlaza al pie de la tienda.',
      hours: 'Horario',
      fulfilment: 'Entrega y pago',
      fee: 'Coste de envío (€, IVA incl.)',
      freeFrom: 'Envío gratis a partir de (€)',
      minOrder: 'Pedido mínimo para envío (€)',
      zeroOff: '0 = sin límite',
      postcodes: 'Códigos postales de reparto',
      postcodesHint: 'Separados por comas. Vacío = reparto a cualquier código postal.',
      deliveryNote: 'Texto del envío (plazo, horario…)',
      pickupNote: 'Texto de la recogida (dónde, cuándo…)',
      bizumPhone: 'Teléfono de Bizum',
      onlineCardHint: 'Necesita tu TPV configurado en Configuración › Cobros online.',
      products: 'Productos',
      productsBody: 'La tienda muestra los artículos de Productos con precio de venta. Para quitar uno, abre el artículo en Productos y desmarca «Mostrar en la tienda online».',
      productsCounts: '{{shown}} en la tienda · {{hidden}} ocultos · {{noPhoto}} sin foto',
      pricePercent: 'Incremento de precio en la web (%)',
      pricePercentHint: '0 = mismos precios que en tienda. 10 sube todos los precios un 10 %; -5 los baja un 5 %. Un artículo con «Precio web» propio usa ese precio.',
      onlyWithPhoto: 'Mostrar solo productos con foto',
      hideOutOfStock: 'Ocultar productos sin stock',
      sellWithoutStock: 'Permitir pedir productos sin stock',
      pauseOrders: 'Pausar pedidos (vacaciones, saturación…)',
      legal: 'Condiciones de compra',
      legalHint: 'Si escribes algo, el cliente debe aceptarlo antes de confirmar el pedido.',
    },
    productToggle: 'Mostrar en la tienda online',
    webPrice: 'Precio web ({{cur}}, IVA incl.)',
    webPriceSame: 'Igual que el precio normal',
    webPriceNow: 'En la tienda online: {{price}}',
    webPricePercent: 'incluye el incremento web del {{percent}} %',
    productsButton: 'Tienda online',
    webSection: 'Sección en la tienda online',
    webSectionSame: 'Su familia / categoría',
    art: {
      schemaMissing: 'Falta aplicar la actualización de la base de datos de la tienda (online_store_update_1.sql). Contacta con soporte.',
      stat: { total: 'Artículos en Productos', shown: 'En la tienda', noSection: 'Sin sección (en «Varios»)', noPhoto: 'Sin foto' },
      sectionsTitle: 'Organizar en secciones',
      sectionsBody: 'Coloca cada artículo en una sección de la tienda (Bebidas, Lácteos, Limpieza…) según su nombre. Solo cambia la sección de la tienda online: las familias y categorías de tus informes no se tocan. Por defecto solo se ordenan los artículos que están en «Varios» o sin categoría.',
      redoAll: 'Volver a calcular también los que ya tienen sección',
      calculate: 'Calcular secciones',
      nothingToSort: 'No hay artículos pendientes de ordenar.',
      unknown: '{{count}} artículos no encajan en ninguna sección: quedan en «Otros productos» y puedes ponerlos a mano abajo.',
      apply: 'Aplicar a {{count}} artículos',
      cancel: 'Cancelar',
      sectionsSaved: '{{count}} artículos actualizados',
      photosTitle: 'Buscar fotos de producto',
      photosBody: 'Busca la foto de cada artículo por su código de barras en Open Food Facts, una base de datos abierta de productos de alimentación y droguería. Solo rellena artículos sin foto: nunca cambia una foto que hayas subido tú. Las fotos se cargan desde Open Food Facts, así que no gastan espacio ni tráfico de tu cuenta. Deja esta pantalla abierta mientras busca.',
      photosLookable: '{{count}} artículos sin foto con código de barras válido · unos {{minutes}} min',
      photosProgress: '{{done}} de {{total}} códigos consultados · {{found}} fotos encontradas',
      photosStart: 'Buscar fotos',
      photosStop: 'Parar',
      photosRetry: 'Volver a consultar todos los códigos',
      photosReset: 'La próxima búsqueda consultará otra vez todos los códigos',
      photosNothing: 'Ya se consultaron todos los códigos. Pulsa «Volver a consultar» para repetir.',
      photosError: 'Open Food Facts no responde ahora. Inténtalo más tarde: la búsqueda sigue donde se quedó.',
      photosDone: 'Búsqueda terminada: {{count}} fotos nuevas',
      photosCredit: 'Fotos de Open Food Facts (licencia CC BY-SA); la tienda lo indica al pie.',
      manualTitle: 'Sección de cada artículo',
      manualBody: 'Los artículos que siguen en «Varios». Escribe o elige su sección y guarda. Busca para cambiar cualquier otro artículo.',
      searchAll: 'Buscar un artículo por nombre o código…',
      saveEdits: 'Guardar ({{count}})',
      pendingCount: '{{count}} artículos sin sección',
      matches: '{{count}} artículos encontrados',
      firstN: 'Se muestran los primeros {{count}}: busca para encontrar el resto.',
    },
  },
};

const en = {
  nav: { online_store: 'Online store' },
  shop: {
    loading: 'Loading the shop…',
    notFoundTitle: 'This shop is not available',
    notFoundBody: 'The link is wrong or the shop is not published yet.',
    errorTitle: 'The shop could not be loaded',
    errorBody: 'Check your connection and try again.',
    draftBanner: 'Preview: the shop is not published yet. Only you can see it and it takes no orders.',
    searchPlaceholder: 'Search products…',
    account: 'My account',
    signIn: 'Sign in',
    signOut: 'Sign out',
    createAccount: 'Create account',
    noAccount: 'No account yet?',
    haveAccount: 'Already have an account?',
    forgotPassword: 'Forgot your password? Contact the shop and they will give you a new one.',
    passwordHint: 'At least 8 characters.',
    cart: 'My basket',
    cartEmpty: 'Your basket is empty.',
    categories: 'Categories',
    allProducts: 'All products',
    resultsFor: 'Results for “{{q}}”',
    productCount_one: '{{count}} product',
    productCount_other: '{{count}} products',
    sort: 'Sort',
    sortName: 'Name',
    sortPriceAsc: 'Price: low to high',
    sortPriceDesc: 'Price: high to low',
    sortNewest: 'Newest',
    sortFeatured: 'Featured',
    otherProducts: 'Other products',
    photosCredit: 'Some product photos:',
    emptyTitle: 'No products',
    emptyBody: 'This section has no products yet.',
    emptySearch: 'Try another word or check the spelling.',
    perLitre: '{{price}} / litre',
    add: 'Add',
    less: 'Remove one',
    more: 'Add one',
    remove: 'Remove from basket',
    close: 'Close',
    inStock: 'Available',
    outOfStock: 'Sold out',
    vatIncluded: 'VAT included',
    pricesIncludeVat: 'All prices include VAT.',
    prevPage: 'Previous page',
    nextPage: 'Next page',
    pageOf: 'Page {{page}} of {{pages}}',
    page: 'Page',
    ofPages: 'of {{pages}}',
    firstPage: 'First page',
    lastPage: 'Last page',
    customerService: 'Customer service',
    callUs: 'Call us on {{phone}}',
    writeUs: 'Email us',
    whatsappUs: 'WhatsApp',
    register: 'Sign up',
    searchLabel: 'Search:',
    home: 'Home',
    hours: 'Opening hours',
    deliveryAndPickup: 'Delivery and collection',
    contact: 'Contact',
    freeFrom: 'Free delivery from {{amount}}',
    minOrder: 'Minimum order: {{amount}}',
    perUnit: '{{price}} / unit',
    perKg: '{{price}} / kg',
    scrollLeft: 'Show previous',
    scrollRight: 'Show more',
    rightsReserved: 'All rights reserved.',
    subtotal: 'Subtotal',
    total: 'Total',
    free: 'Free',
    checkout: 'Checkout',
    ordersPaused: 'We are not taking orders right now',
    toFreeDelivery: '{{amount}} more for free delivery.',
    belowMinimum: 'The minimum order for home delivery is {{amount}}.',
    backToShop: 'Back to the shop',
    yourDetails: 'Your details',
    name: 'Full name',
    phone: 'Phone',
    email: 'Email',
    password: 'Password',
    emailOptional: 'Email (optional)',
    nifOptional: 'Tax ID (if you want an invoice)',
    howToReceive: 'How do you want to receive it?',
    delivery: 'Home delivery',
    pickup: 'Collect in store',
    pickupHint: 'We will let you know when it is ready.',
    deliveryCost: 'Delivery cost: {{amount}}',
    deliveryFree: 'Free delivery',
    street: 'Address (street, number, flat)',
    postcode: 'Postcode',
    city: 'Town',
    payment: 'Payment method',
    noPaymentMethods: 'The shop has not set up payment methods yet.',
    notes: 'Order notes',
    yourOrder: 'Your order',
    acceptTerms: 'I accept the terms of purchase',
    placeOrder: 'Place order',
    pay: {
      cash: 'Cash on receipt',
      card_on_delivery: 'Card on receipt (card reader)',
      bizum: 'Bizum',
      transfer: 'Bank transfer',
      online_card: 'Card online',
    },
    payHint: {
      cash: 'Pay in cash to the driver or in the shop.',
      card_on_delivery: 'Pay by card to the driver or in the shop.',
      bizum: 'We show you the number when the order is confirmed.',
      transfer: 'We show you the account when the order is confirmed.',
      online_card: 'Secure card payment when the order is confirmed.',
    },
    payStatus: { pending: 'Payment pending', paid: 'Paid', refunded: 'Refunded' },
    status: {
      new: 'Received', accepted: 'Accepted', preparing: 'Being prepared', ready: 'Ready to collect',
      shipped: 'Out for delivery', delivered: 'Delivered', cancelled: 'Cancelled',
    },
    orderReceived: 'Order received!',
    orderCancelled: 'Order cancelled',
    orderNumber: 'Order {{number}}',
    orderNotFound: 'We cannot find this order.',
    vatLine: 'VAT {{rate}}% included',
    transferTo: 'Transfer to {{iban}} quoting order {{number}}.',
    bizumTo: 'Send the Bizum to {{phone}} quoting order {{number}}.',
    payNowTitle: 'Order payment',
    payByCard: 'Pay {{amount}} by card',
    payConfirming: 'Confirming the payment with the bank…',
    payFailed: 'The payment was not completed. You can try again.',
    myOrders: 'My orders',
    noOrders: 'You have not placed any order yet.',
    myDetails: 'My details',
    save: 'Save',
    saved: 'Saved',
    err: {
      failed: 'It could not be completed. Try again.',
      accept_terms: 'You must accept the terms of purchase.',
      store_not_available: 'The shop is not available right now.',
      orders_paused: 'The shop is not taking orders at the moment.',
      name_required: 'Enter your name.',
      phone_invalid: 'Enter a valid phone number.',
      email_invalid: 'The email is not valid.',
      email_taken: 'An account with that email already exists. Sign in.',
      password_invalid: 'The password needs at least 8 characters.',
      bad_credentials: 'Wrong email or password.',
      rate_limited: 'Too many attempts. Wait a few minutes.',
      fulfilment_invalid: 'That delivery option is not available.',
      address_required: 'Enter the full delivery address.',
      postcode_not_served: 'We do not deliver to that postcode. You can choose collect in store.',
      payment_invalid: 'That payment method is not available.',
      items_invalid: 'The basket is not valid.',
      items_unavailable: 'A product is no longer available. We updated your basket: please check it.',
      out_of_stock: 'A product has sold out. We updated your basket: please check it.',
      below_minimum: 'The order is below the minimum for home delivery.',
      not_signed_in: 'Your session has expired. Sign in again.',
    },
  },
  ostore: {
    title: 'Online store',
    intro: 'Your own web shop with the products you already have in zBilling: customers buy online and the orders arrive here.',
    schemaMissing: 'The module is enabled but not installed in the database yet. Contact support.',
    create: 'Create my shop',
    draft: 'Draft',
    published: 'Published',
    publish: 'Publish shop',
    unpublish: 'Unpublish',
    publishedToast: 'Shop published: it now takes orders',
    unpublished: 'Shop unpublished',
    preview: 'Preview',
    openShop: 'Open shop',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    save: 'Save changes',
    saved: 'Changes saved',
    saveFailed: 'It could not be saved',
    loadFailed: 'Orders could not be loaded',
    uploadFailed: 'The image could not be uploaded (PNG, JPG or WebP, max 5 MB)',
    close: 'Close',
    refresh: 'Refresh',
    print: 'Print',
    tab: { orders: 'Orders', reports: 'Sales reports', articles: 'Articles', customers: 'Customers', settings: 'Settings' },
    filter: { open: 'In progress', all: 'All' },
    searchOrders: 'Search order, customer or phone…',
    noOrders: 'No orders yet. Publish the shop and share the link.',
    noOrdersFilter: 'No orders match that filter.',
    col: { order: 'Order', date: 'Date', customer: 'Customer', receive: 'Delivery', payment: 'Payment', total: 'Total', status: 'Status', contact: 'Contact', since: 'Since', orders: 'Orders' },
    product: 'Product',
    qty: 'Qty',
    price: 'Price',
    vatBase: 'Base + VAT {{rate}}%',
    moveTo: {
      accepted: 'Accept order', preparing: 'Start preparing', ready: 'Ready to collect',
      shipped: 'Out for delivery', delivered: 'Delivered', cancelled: 'Cancel order',
    },
    markPaid: 'Mark as paid',
    markUnpaid: 'Mark as unpaid',
    period: { today: 'Today', d7: '7 days', d30: '30 days', month: 'This month', year: 'This year', all: 'All time' },
    exportCsv: 'Export CSV',
    kpi: {
      sales: 'Sales', vatIncluded: 'VAT included', orders: 'Orders', cancelled: '{{count}} cancelled', average: 'Average order',
      customers: 'Customers', paid: 'Collected', pending: 'To collect', delivery: 'Home deliveries',
      deliveryFees: '{{amount}} in delivery fees', pickup: 'Store collections',
    },
    salesByDay: 'Sales by day',
    topProducts: 'Best-selling products',
    byPayment: 'By payment method',
    noData: 'No data in this period.',
    noCustomers: 'No customers have signed up in the shop yet.',
    resetPassword: 'New password',
    resetPrompt: 'New password for {{email}} (at least 8 characters). Pass it on to the customer:',
    resetDone: 'Password changed',
    err: {
      failed: 'It could not be saved',
      slug_invalid: 'The address takes lowercase letters, numbers and hyphens only (3 to 60 characters)',
      slug_taken: 'Another shop already uses that address',
      domain_invalid: 'The domain is not valid (example: shop.mybusiness.com)',
      domain_taken: 'That domain is already connected to another shop',
      forbidden: 'You are not allowed to change the shop',
    },
    set: {
      identity: 'Your shop',
      name: 'Shop name',
      tagline: 'Line under the cover image',
      slug: 'Shop address',
      domain: 'Own domain (optional)',
      domainHint: 'If you have your own website or domain, type it here and tell support to connect it.',
      logo: 'Logo',
      banner: 'Cover image',
      colour: 'Main colour',
      notice: 'Notice across the top',
      contact: 'Contact',
      address: 'Shop address',
      website: 'Your other website',
      websiteHint: 'Linked in the shop footer.',
      hours: 'Opening hours',
      fulfilment: 'Delivery and payment',
      fee: 'Delivery cost (€, VAT incl.)',
      freeFrom: 'Free delivery from (€)',
      minOrder: 'Minimum order for delivery (€)',
      zeroOff: '0 = no limit',
      postcodes: 'Delivery postcodes',
      postcodesHint: 'Separated by commas. Empty = delivery to any postcode.',
      deliveryNote: 'Delivery text (lead time, hours…)',
      pickupNote: 'Collection text (where, when…)',
      bizumPhone: 'Bizum phone',
      onlineCardHint: 'Needs your card terminal set up in Settings › Online payments.',
      products: 'Products',
      productsBody: 'The shop shows the articles in Products that have a sale price. To take one out, open it in Products and untick “Show in the online store”.',
      productsCounts: '{{shown}} in the shop · {{hidden}} hidden · {{noPhoto}} without photo',
      pricePercent: 'Web price increase (%)',
      pricePercentHint: '0 = same prices as in the shop. 10 raises every price by 10%; -5 lowers them by 5%. An article with its own “Web price” uses that price.',
      onlyWithPhoto: 'Show only products with a photo',
      hideOutOfStock: 'Hide out-of-stock products',
      sellWithoutStock: 'Allow ordering out-of-stock products',
      pauseOrders: 'Pause orders (holidays, overload…)',
      legal: 'Terms of purchase',
      legalHint: 'If you write something, the customer must accept it before placing the order.',
    },
    productToggle: 'Show in the online store',
    webPrice: 'Web price ({{cur}}, VAT incl.)',
    webPriceSame: 'Same as the normal price',
    webPriceNow: 'In the online store: {{price}}',
    webPricePercent: 'includes the {{percent}}% web increase',
    productsButton: 'Online store',
    webSection: 'Section in the online store',
    webSectionSame: 'Its family / category',
    art: {
      schemaMissing: 'The shop\'s database update (online_store_update_1.sql) is not applied yet. Contact support.',
      stat: { total: 'Articles in Products', shown: 'In the shop', noSection: 'No section (in “Varios”)', noPhoto: 'No photo' },
      sectionsTitle: 'Sort into sections',
      sectionsBody: 'Puts each article in a shop section (Drinks, Dairy, Cleaning…) based on its name. It only changes the online shop section: the families and categories your reports use stay as they are. By default only articles in “Varios” or without a category are sorted.',
      redoAll: 'Also recalculate the ones that already have a section',
      calculate: 'Work out sections',
      nothingToSort: 'No articles waiting to be sorted.',
      unknown: '{{count}} articles fit no section: they stay in “Other products” and you can set them by hand below.',
      apply: 'Apply to {{count}} articles',
      cancel: 'Cancel',
      sectionsSaved: '{{count}} articles updated',
      photosTitle: 'Find product photos',
      photosBody: 'Looks up each article’s photo by its barcode on Open Food Facts, an open database of grocery and household products. It only fills articles without a photo: a photo you uploaded is never changed. The photos load from Open Food Facts, so they use none of your account’s space or traffic. Keep this screen open while it searches.',
      photosLookable: '{{count}} articles without a photo and with a valid barcode · about {{minutes}} min',
      photosProgress: '{{done}} of {{total}} barcodes checked · {{found}} photos found',
      photosStart: 'Find photos',
      photosStop: 'Stop',
      photosRetry: 'Check every barcode again',
      photosReset: 'The next search will check every barcode again',
      photosNothing: 'Every barcode has been checked already. Press “Check every barcode again” to repeat.',
      photosError: 'Open Food Facts is not answering right now. Try later: the search continues where it stopped.',
      photosDone: 'Search finished: {{count}} new photos',
      photosCredit: 'Photos from Open Food Facts (CC BY-SA licence); the shop credits them in its footer.',
      manualTitle: 'Section of each article',
      manualBody: 'The articles still in “Varios”. Type or pick their section and save. Search to change any other article.',
      searchAll: 'Search an article by name or barcode…',
      saveEdits: 'Save ({{count}})',
      pendingCount: '{{count}} articles without a section',
      matches: '{{count}} articles found',
      firstN: 'Showing the first {{count}}: search to find the rest.',
    },
  },
};

const ca = {
  nav: { online_store: 'Botiga en línia' },
  shop: {
    loading: 'Carregant la botiga…',
    notFoundTitle: 'Aquesta botiga no està disponible',
    notFoundBody: "L'enllaç no és correcte o la botiga encara no està publicada.",
    errorTitle: "No s'ha pogut carregar la botiga",
    errorBody: 'Comprova la connexió i torna-ho a provar.',
    draftBanner: 'Vista prèvia: la botiga encara no està publicada. Només tu la pots veure i no admet comandes.',
    searchPlaceholder: 'Cerca productes…',
    account: 'El meu compte',
    signIn: 'Inicia la sessió',
    signOut: 'Tanca la sessió',
    createAccount: 'Crea un compte',
    noAccount: 'Encara no tens compte?',
    haveAccount: 'Ja tens compte?',
    forgotPassword: "Has oblidat la contrasenya? Contacta amb la botiga i te'n donarà una de nova.",
    passwordHint: 'Mínim 8 caràcters.',
    cart: 'La meva cistella',
    cartEmpty: 'La cistella és buida.',
    categories: 'Categories',
    allProducts: 'Tots els productes',
    resultsFor: 'Resultats per a «{{q}}»',
    productCount_one: '{{count}} producte',
    productCount_other: '{{count}} productes',
    sort: 'Ordena',
    sortName: 'Nom',
    sortPriceAsc: 'Preu: de menor a major',
    sortPriceDesc: 'Preu: de major a menor',
    sortNewest: 'Novetats',
    sortFeatured: 'Destacats',
    otherProducts: 'Altres productes',
    photosCredit: 'Algunes fotos de producte:',
    emptyTitle: 'No hi ha productes',
    emptyBody: 'Aquesta secció encara no té productes.',
    emptySearch: "Prova amb una altra paraula o revisa l'ortografia.",
    perLitre: '{{price}} / litre',
    add: 'Afegeix',
    less: "Treu-ne un",
    more: "Afegeix-ne un",
    remove: 'Treu de la cistella',
    close: 'Tanca',
    inStock: 'Disponible',
    outOfStock: 'Esgotat',
    vatIncluded: 'IVA inclòs',
    pricesIncludeVat: "Tots els preus inclouen l'IVA.",
    prevPage: 'Pàgina anterior',
    nextPage: 'Pàgina següent',
    pageOf: 'Pàgina {{page}} de {{pages}}',
    page: 'Pàgina',
    ofPages: 'de {{pages}}',
    firstPage: 'Primera pàgina',
    lastPage: 'Última pàgina',
    customerService: 'Atenció al client',
    callUs: "Truca'ns al {{phone}}",
    writeUs: 'Escriu-nos',
    whatsappUs: 'WhatsApp',
    register: "Registra't",
    searchLabel: 'Cerca:',
    home: 'Inici',
    hours: 'Horaris',
    deliveryAndPickup: 'Lliurament i recollida',
    contact: 'Contacte',
    freeFrom: 'Enviament gratuït des de {{amount}}',
    minOrder: 'Comanda mínima: {{amount}}',
    perUnit: '{{price}} / u.',
    perKg: '{{price}} / kg',
    scrollLeft: 'Mostra els anteriors',
    scrollRight: "Mostra'n més",
    rightsReserved: 'Tots els drets reservats.',
    subtotal: 'Subtotal',
    total: 'Total',
    free: 'Gratis',
    checkout: 'Tramita la comanda',
    ordersPaused: 'Ara no admetem comandes',
    toFreeDelivery: "Et falten {{amount}} per a l'enviament gratuït.",
    belowMinimum: 'La comanda mínima per a enviament a domicili és de {{amount}}.',
    backToShop: 'Torna a la botiga',
    yourDetails: 'Les teves dades',
    name: 'Nom i cognoms',
    phone: 'Telèfon',
    email: 'Correu electrònic',
    password: 'Contrasenya',
    emailOptional: 'Correu electrònic (opcional)',
    nifOptional: 'NIF (si vols factura)',
    howToReceive: 'Com ho vols rebre?',
    delivery: 'Enviament a domicili',
    pickup: 'Recollida a la botiga',
    pickupHint: "T'avisem quan estigui a punt.",
    deliveryCost: "Cost d'enviament: {{amount}}",
    deliveryFree: 'Enviament gratuït',
    street: 'Adreça (carrer, número, pis)',
    postcode: 'Codi postal',
    city: 'Població',
    payment: 'Forma de pagament',
    noPaymentMethods: 'La botiga encara no ha configurat formes de pagament.',
    notes: 'Notes per a la comanda',
    yourOrder: 'La teva comanda',
    acceptTerms: 'Accepto les condicions de compra',
    placeOrder: 'Confirma la comanda',
    pay: {
      cash: 'Efectiu en rebre',
      card_on_delivery: 'Targeta en rebre (datàfon)',
      bizum: 'Bizum',
      transfer: 'Transferència bancària',
      online_card: 'Targeta en línia',
    },
    payHint: {
      cash: 'Pagues en efectiu al repartidor o a la botiga.',
      card_on_delivery: 'Pagues amb targeta al repartidor o a la botiga.',
      bizum: "T'indiquem el número en confirmar la comanda.",
      transfer: "T'indiquem el compte en confirmar la comanda.",
      online_card: 'Pagament segur amb targeta en confirmar la comanda.',
    },
    payStatus: { pending: 'Pendent de pagament', paid: 'Pagat', refunded: 'Retornat' },
    status: {
      new: 'Rebuda', accepted: 'Acceptada', preparing: 'En preparació', ready: 'A punt per recollir',
      shipped: 'En repartiment', delivered: 'Lliurada', cancelled: 'Cancel·lada',
    },
    orderReceived: 'Comanda rebuda!',
    orderCancelled: 'Comanda cancel·lada',
    orderNumber: 'Comanda {{number}}',
    orderNotFound: 'No trobem aquesta comanda.',
    vatLine: 'IVA {{rate}} % inclòs',
    transferTo: 'Fes la transferència a {{iban}} indicant la comanda {{number}}.',
    bizumTo: 'Envia el Bizum al {{phone}} indicant la comanda {{number}}.',
    payNowTitle: 'Pagament de la comanda',
    payByCard: 'Paga {{amount}} amb targeta',
    payConfirming: 'Confirmant el pagament amb el banc…',
    payFailed: "El pagament no s'ha completat. Ho pots tornar a provar.",
    myOrders: 'Les meves comandes',
    noOrders: 'Encara no has fet cap comanda.',
    myDetails: 'Les meves dades',
    save: 'Desa',
    saved: 'Desat',
    err: {
      failed: "No s'ha pogut completar. Torna-ho a provar.",
      accept_terms: "Has d'acceptar les condicions de compra.",
      store_not_available: 'La botiga no està disponible ara mateix.',
      orders_paused: 'La botiga no admet comandes en aquest moment.',
      name_required: 'Indica el teu nom.',
      phone_invalid: 'Indica un telèfon vàlid.',
      email_invalid: 'El correu electrònic no és vàlid.',
      email_taken: 'Ja hi ha un compte amb aquest correu. Inicia la sessió.',
      password_invalid: 'La contrasenya ha de tenir almenys 8 caràcters.',
      bad_credentials: 'Correu o contrasenya incorrectes.',
      rate_limited: 'Massa intents. Espera uns minuts.',
      fulfilment_invalid: 'Aquesta forma de lliurament no està disponible.',
      address_required: "Indica l'adreça de lliurament completa.",
      postcode_not_served: 'No repartim en aquest codi postal. Pots triar recollida a la botiga.',
      payment_invalid: 'Aquesta forma de pagament no està disponible.',
      items_invalid: 'La cistella no és vàlida.',
      items_unavailable: 'Algun producte ja no està disponible. Hem actualitzat la cistella: revisa-la.',
      out_of_stock: "Algun producte s'ha esgotat. Hem actualitzat la cistella: revisa-la.",
      below_minimum: 'La comanda no arriba al mínim per a enviament a domicili.',
      not_signed_in: 'La sessió ha caducat. Torna a iniciar-la.',
    },
  },
  ostore: {
    title: 'Botiga en línia',
    intro: 'La teva pròpia botiga web amb els productes que ja tens a zBilling: els clients compren en línia i les comandes t\'arriben aquí.',
    schemaMissing: 'El mòdul està activat però pendent d\'instal·lar a la base de dades. Contacta amb suport.',
    create: 'Crea la meva botiga',
    draft: 'Esborrany',
    published: 'Publicada',
    publish: 'Publica la botiga',
    unpublish: 'Despublica',
    publishedToast: 'Botiga publicada: ja admet comandes',
    unpublished: 'Botiga despublicada',
    preview: 'Vista prèvia',
    openShop: 'Obre la botiga',
    copyLink: "Copia l'enllaç",
    linkCopied: 'Enllaç copiat',
    save: 'Desa els canvis',
    saved: 'Canvis desats',
    saveFailed: "No s'ha pogut desar",
    loadFailed: "No s'han pogut carregar les comandes",
    uploadFailed: "No s'ha pogut pujar la imatge (PNG, JPG o WebP, màx. 5 MB)",
    close: 'Tanca',
    refresh: 'Actualitza',
    print: 'Imprimeix',
    tab: { orders: 'Comandes', reports: 'Informes de venda', articles: 'Articles', customers: 'Clients', settings: 'Configuració' },
    filter: { open: 'En curs', all: 'Totes' },
    searchOrders: 'Cerca comanda, client o telèfon…',
    noOrders: "Encara no hi ha comandes. Publica la botiga i comparteix l'enllaç.",
    noOrdersFilter: 'Cap comanda amb aquest filtre.',
    col: { order: 'Comanda', date: 'Data', customer: 'Client', receive: 'Lliurament', payment: 'Pagament', total: 'Total', status: 'Estat', contact: 'Contacte', since: 'Alta', orders: 'Comandes' },
    product: 'Producte',
    qty: 'Quant.',
    price: 'Preu',
    vatBase: 'Base + IVA {{rate}} %',
    moveTo: {
      accepted: 'Accepta la comanda', preparing: 'Comença a preparar', ready: 'A punt per recollir',
      shipped: 'Surt a repartiment', delivered: 'Lliurada', cancelled: 'Cancel·la la comanda',
    },
    markPaid: 'Marca com a pagada',
    markUnpaid: 'Marca com a no pagada',
    period: { today: 'Avui', d7: '7 dies', d30: '30 dies', month: 'Aquest mes', year: 'Aquest any', all: 'Tot' },
    exportCsv: 'Exporta CSV',
    kpi: {
      sales: 'Vendes', vatIncluded: 'IVA inclòs', orders: 'Comandes', cancelled: '{{count}} cancel·lades', average: 'Tiquet mitjà',
      customers: 'Clients', paid: 'Cobrat', pending: 'Pendent de cobrament', delivery: 'Enviaments a domicili',
      deliveryFees: "{{amount}} en despeses d'enviament", pickup: 'Recollides a la botiga',
    },
    salesByDay: 'Vendes per dia',
    topProducts: 'Productes més venuts',
    byPayment: 'Per forma de pagament',
    noData: 'Sense dades en aquest període.',
    noCustomers: 'Encara no hi ha clients registrats a la botiga.',
    resetPassword: 'Nova contrasenya',
    resetPrompt: 'Nova contrasenya per a {{email}} (mínim 8 caràcters). Comunica-la al client:',
    resetDone: 'Contrasenya canviada',
    err: {
      failed: "No s'ha pogut desar",
      slug_invalid: "L'adreça només admet minúscules, números i guions (de 3 a 60 caràcters)",
      slug_taken: 'Aquesta adreça ja la fa servir una altra botiga',
      domain_invalid: 'El domini no és vàlid (exemple: botiga.elmeunegoci.cat)',
      domain_taken: 'Aquest domini ja està connectat a una altra botiga',
      forbidden: 'No tens permís per canviar la botiga',
    },
    set: {
      identity: 'La teva botiga',
      name: 'Nom de la botiga',
      tagline: 'Frase sota la imatge de portada',
      slug: 'Adreça de la botiga',
      domain: 'Domini propi (opcional)',
      domainHint: "Si tens la teva pròpia web o domini, escriu-lo aquí i avisa suport per connectar-lo.",
      logo: 'Logotip',
      banner: 'Imatge de portada',
      colour: 'Color principal',
      notice: 'Avís a la part superior',
      contact: 'Contacte',
      address: 'Adreça de la botiga',
      website: 'La teva altra web',
      websiteHint: "S'enllaça al peu de la botiga.",
      hours: 'Horari',
      fulfilment: 'Lliurament i pagament',
      fee: "Cost d'enviament (€, IVA incl.)",
      freeFrom: 'Enviament gratuït a partir de (€)',
      minOrder: 'Comanda mínima per a enviament (€)',
      zeroOff: '0 = sense límit',
      postcodes: 'Codis postals de repartiment',
      postcodesHint: 'Separats per comes. Buit = repartiment a qualsevol codi postal.',
      deliveryNote: "Text de l'enviament (termini, horari…)",
      pickupNote: 'Text de la recollida (on, quan…)',
      bizumPhone: 'Telèfon de Bizum',
      onlineCardHint: 'Cal el teu TPV configurat a Configuració › Cobraments en línia.',
      products: 'Productes',
      productsBody: "La botiga mostra els articles de Productes amb preu de venda. Per treure'n un, obre l'article a Productes i desmarca «Mostra a la botiga en línia».",
      productsCounts: '{{shown}} a la botiga · {{hidden}} ocults · {{noPhoto}} sense foto',
      pricePercent: 'Increment de preu al web (%)',
      pricePercentHint: '0 = mateixos preus que a la botiga. 10 apuja tots els preus un 10 %; -5 els abaixa un 5 %. Un article amb «Preu web» propi fa servir aquest preu.',
      onlyWithPhoto: 'Mostra només productes amb foto',
      hideOutOfStock: 'Amaga els productes sense estoc',
      sellWithoutStock: 'Permet demanar productes sense estoc',
      pauseOrders: 'Pausa les comandes (vacances, saturació…)',
      legal: 'Condicions de compra',
      legalHint: 'Si hi escrius alguna cosa, el client ho ha d\'acceptar abans de confirmar la comanda.',
    },
    productToggle: 'Mostra a la botiga en línia',
    webPrice: 'Preu web ({{cur}}, IVA incl.)',
    webPriceSame: 'Igual que el preu normal',
    webPriceNow: 'A la botiga en línia: {{price}}',
    webPricePercent: "inclou l'increment web del {{percent}} %",
    productsButton: 'Botiga en línia',
    webSection: 'Secció a la botiga en línia',
    webSectionSame: 'La seva família / categoria',
    art: {
      schemaMissing: 'Falta aplicar l\'actualització de la base de dades de la botiga (online_store_update_1.sql). Contacta amb suport.',
      stat: { total: 'Articles a Productes', shown: 'A la botiga', noSection: 'Sense secció (a «Varios»)', noPhoto: 'Sense foto' },
      sectionsTitle: 'Organitza en seccions',
      sectionsBody: 'Col·loca cada article en una secció de la botiga (Begudes, Làctics, Neteja…) segons el seu nom. Només canvia la secció de la botiga en línia: les famílies i categories dels teus informes no es toquen. Per defecte només s\'ordenen els articles que són a «Varios» o sense categoria.',
      redoAll: 'Torna a calcular també els que ja tenen secció',
      calculate: 'Calcula les seccions',
      nothingToSort: 'No hi ha articles pendents d’ordenar.',
      unknown: '{{count}} articles no encaixen en cap secció: queden a «Altres productes» i els pots posar a mà a sota.',
      apply: 'Aplica a {{count}} articles',
      cancel: 'Cancel·la',
      sectionsSaved: '{{count}} articles actualitzats',
      photosTitle: 'Cerca fotos de producte',
      photosBody: 'Cerca la foto de cada article pel seu codi de barres a Open Food Facts, una base de dades oberta de productes d\'alimentació i drogueria. Només omple articles sense foto: mai no canvia una foto que hagis pujat tu. Les fotos es carreguen des d\'Open Food Facts, així que no gasten espai ni trànsit del teu compte. Deixa aquesta pantalla oberta mentre cerca.',
      photosLookable: '{{count}} articles sense foto amb codi de barres vàlid · uns {{minutes}} min',
      photosProgress: '{{done}} de {{total}} codis consultats · {{found}} fotos trobades',
      photosStart: 'Cerca fotos',
      photosStop: 'Atura',
      photosRetry: 'Torna a consultar tots els codis',
      photosReset: 'La propera cerca tornarà a consultar tots els codis',
      photosNothing: 'Ja s’han consultat tots els codis. Prem «Torna a consultar» per repetir.',
      photosError: 'Open Food Facts no respon ara. Torna-ho a provar més tard: la cerca continua on s’havia quedat.',
      photosDone: 'Cerca acabada: {{count}} fotos noves',
      photosCredit: 'Fotos d\'Open Food Facts (llicència CC BY-SA); la botiga ho indica al peu.',
      manualTitle: 'Secció de cada article',
      manualBody: 'Els articles que continuen a «Varios». Escriu o tria la secció i desa. Cerca per canviar qualsevol altre article.',
      searchAll: 'Cerca un article per nom o codi…',
      saveEdits: 'Desa ({{count}})',
      pendingCount: '{{count}} articles sense secció',
      matches: '{{count}} articles trobats',
      firstN: 'Es mostren els primers {{count}}: cerca per trobar la resta.',
    },
  },
};

const onlineStoreStrings = { es, en, ca };
export default onlineStoreStrings;
